import React from 'react';
import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/styles';
import styles from './Loading.styles';

const Loading = props => {
  window.ReactMCUI = React;

  return <CircularProgress {...props} />;
};
Loading.defaultProps = {};
Loading.propTypes = {
  prop: PropTypes.string,
};

export default Loading;
